module.exports = __webpack_public_path__ + "img/trending_down.d6288c25.svg";